import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentrifugeSeparatorDisc = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 110,
	viewBox: "0 0 100.0 110.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 50.0 10.0 L 50.0 110.0 M 10.0 90.0 L 90.0 90.0 M 10.0 35.0 L 50.0 10.0 L 90.0 35.0 M 10.0 50.0 L 50.0 25.0 L 90.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgCentrifugeSeparatorDisc;
